import { useEffect, useState } from "react";
import { FiBarChart2 } from "react-icons/fi";
import { axiosInstance } from "../../api/axiosInstance";
import { LiveMarketTickerWrapper } from "./live-market-ticker.styles";
import { useNavigate } from "react-router";
import { Mixpanel } from "../../utils/mixpanel";

const LIVE_PRICES_CACHE_KEY = "agrogrid_live_market_prices_lagos";
const fallbackLivePrices = [
  { type: "tomato", emoji: "🍅", name: "Tomatoes", price: "₦3,200", unit: "per kg", change: "↗ 8.5%", direction: "up" },
  { type: "onion", emoji: "🧅", name: "Onions (50kg Bag)", price: "₦34,200", unit: "per bag", change: "↘ 1.2%", direction: "down" },
  { type: "tomato", emoji: "🍅", name: "Tomatoes", price: "₦3,200", unit: "per kg", change: "↗ 8.5%", direction: "up" },
  { type: "leaf", emoji: "🌿", name: "Ugwu Leaves", price: "₦500", unit: "per bundle", change: "↘ 0.8%", direction: "down" },
  { type: "pepper", emoji: "🌶️", name: "Tatashe Peppers", price: "₦9,100", unit: "per basket", change: "↗ 2.6%", direction: "up" },
];

const readCachedPrices = () => {
  try {
    const cached = sessionStorage.getItem(LIVE_PRICES_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

const mapLivePrice = (item) => {
  const direction = String(item?.change_direction || "").toLowerCase();
  const percentage = Number(item?.change_percentage);
  return {
    emoji: item?.emoji || "🌿",
    name: item?.display_name || item?.commodity_name || "Commodity",
    price: `₦${Number(item?.latest_price_ngn || 0).toLocaleString("en-NG")}`,
    unit: item?.unit ? `per ${item.unit}` : "",
    change: Number.isFinite(percentage) ? `${direction === "down" ? "↘" : "↗"} ${Math.abs(percentage)}%` : "—",
    direction: direction === "down" ? "down" : direction === "up" ? "up" : "neutral",
  };
};

export const LiveMarketTicker = () => {
  const navigate = useNavigate()
  const [livePrices, setLivePrices] = useState(() => readCachedPrices() || fallbackLivePrices);

  useEffect(() => {
    let isMounted = true;
    axiosInstance.get("/market-prices/live", { params: { state: "lagos" } }).then(({ data }) => {
      const prices = Array.isArray(data?.data) ? data.data.map(mapLivePrice) : [];
      if (isMounted && prices.length) {
        setLivePrices(prices);
        try {
          sessionStorage.setItem(LIVE_PRICES_CACHE_KEY, JSON.stringify(prices));
        } catch { /* storage is optional */ }
      }
    }).catch(() => undefined);
    return () => { isMounted = false; };
  }, []);

  return <LiveMarketTickerWrapper className="tw-cursor-pointer" onClick={()=>{
    Mixpanel.track("Tap-ViewPriceList")
    navigate("/market-prices")
  }}  aria-label="Live market prices">
    <span className="ticker-label"><FiBarChart2 aria-hidden="true" />Live Market Prices</span>
    <div className="ticker-viewport">
      <div className="market-ticker-content">
        {[...livePrices, ...livePrices].map((item, index) => <span className="ticker-item" key={`${item.name}-${item.unit}-${index}`}>
          <i className="ticker-emoji" aria-hidden="true">{item.emoji}</i>
          <span>{item.name}</span>
          <strong>{item.price}
            {/* <small>{item.unit}</small> */}
            </strong>
          <b className={item.direction}>{item.change}</b></span>
        )}
      </div>
    </div>
    <div className="ticker-price-list tw-cursor-pointer">View Price List</div>
  </LiveMarketTickerWrapper>;
};
